<template>
  <div v-if="isUserAuthenticated()">
    <!-- contractId:{{contractId}} -->
    <v-toolbar flat color="white">
      <v-toolbar-title>Paiements</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="525px">
        <v-btn slot="activator" color="primary" dark class="mb-2" @click="createItem()">Nouveau paiement</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs4 sm4 md4>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="editedItem.Date"
                      label="Date"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="date" no-title @input="savePaymentDate(editedItem, date)"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-text-field v-model="editedItem.Amount" label="Montant"></v-text-field>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-checkbox v-model="editedItem.IsActive" label="Est actif"></v-checkbox>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuCheckDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="editedItem.CheckDate"
                      label="Date chèque"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="checkDate" no-title @input="saveCheckDate(editedItem, checkDate)"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-text-field v-model="editedItem.CheckNumber" label="N° Chèque"></v-text-field>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-checkbox v-model="editedItem.IsNSF" label="Est NSF"></v-checkbox>
                </v-flex>
                <v-flex xs8 sm8 md8>
                  <v-combobox
                      :items="depositItems"
                      v-model="editedItem.Deposit"
                      item-text="ID"
                      item-value="ID"
                      label="Numéro de dépôt"
                      hide-details
                      required
                  ></v-combobox>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-checkbox v-model="editedItem.IsRebate" label="Est Rabais"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-combobox
                      :items="paymentmethodtypeitems"
                      v-model="editedItem.PaymentMethodType"
                      item-text="Name"
                      item-value="ID"
                      label="Méthode de paiement"
                      hide-details
                      :rules="requiredRules"
                      required
                  ></v-combobox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Annuler</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save">Sauvegarder</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-1"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                pagination2.descending ? 'desc' : 'asc',
                header.value === pagination2.sortBy ? 'active' : '',
                header.align ? 'text-xs-' + header.align : ''
              ]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ contractId }}</td>
          <td class="text-xs-left">{{ props.item.Date | formatDate }}</td>
          <td class="text-xs-left">{{ props.item.CheckNumber }}</td>
          <td class="text-xs-left">{{ props.item.CheckDate | formatDate }}</td>
          <td class="text-xs-left">{{ props.item.Amount }}</td>
          <td class="justify-center layout px-0">
            <v-icon medium class="mr-2" @click="editItem(props.item)">edit</v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import auth from '@/auth'
import APIPayment from '@/api/payment'
import APIDeposit from '@/api/deposit'
import APIPaymentMethodType from '@/api/paymentmethodtype'
const APIService = new APIPayment();
const APIDepositService = new APIDeposit();
const APIPaymentMethodTypeService = new APIPaymentMethodType();

var axios = require('axios')

export default {

  props: {
    contractId: {
      type: Number,
      required: true
   }
  },
  data() {
    return {
        date: null,
        checkDate: null,
        menu: false,
        menuCheckDate: false,
        modal: false,

        dialog: false,
        loading: false,
        pagination2: {
          sortBy: 'Name',
          page: 1,
          rowsPerPage: 3
        },
        headers : [
          { text: 'N° facture', value: 'ID', align: 'left' },
          { text: 'Date paiement', value: 'Date', align: 'left' },
          { text: 'N° chèque', value: 'CheckNumber', align: 'left' },
          { text: 'Date chèque', value: 'CheckDate', align: 'left' },
          { text: 'Montant', value: 'Amount', align: 'left' },
          { text: 'Actions', value: 'Actions', align: 'center', sortable: false }
        ],
        requiredRules: [
          (v) => !!v || 'Field is required.',
        ],
        items: [],
        paymentmethodtypeitems: [],
        depositItems: [],
        depositItem: '',
        editedIndex: -1,
        editedItem: {},
        defaultItem: {
          Deposit: null,
          PaymentMethodType: null,
          Date: moment().format("YYYY-MM-DD"),
          CheckDate: null,
          CheckNumber: null,
          IsActive: true
        }
    }
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nouveau paiement' : 'Modification du paiement'
    },

    pages2 () {
      if (this.pagination2.rowsPerPage == null || this.pagination2.totalItems == null)
        return 0

      return Math.ceil(this.pagination2.totalItems / this.pagination2.rowsPerPage)
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    contractId () {
      this.initialize()
    },
    items () {
      this.$nextTick(() => {
        this.pagination2.totalItems = this.items.length
      })
    }
  },

  created(){
    this.initialize()
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    logout() {
      auth.logout()
    },

    initialize () {
      var payments = APIService.getAll(this.contractId).then(response =>  {
            this.items = response.data
        }
      )

      var deposits = APIDepositService.getAll().then(response =>  {
            this.depositItems = response.data
        }
      )

      APIPaymentMethodTypeService.getAll().then(response =>  {
            this.paymentmethodtypeitems = response.data
        }
      )

    },

    changeSort (column) {
      if (this.pagination2.sortBy === column) {
        this.pagination2.descending = !this.pagination2.descending
      } else {
        this.pagination2.sortBy = column
        this.pagination2.descending = false
      }
    },

    createItem () {
      //debugger
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItem.PaymentMethodType = this.paymentmethodtypeitems.find(o => { return o.Code === "CHQ" })
      this.editedIndex = -1
      this.dialog = true
    },

    editItem (item) {
      //debugger;
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.Date = moment(this.editedItem.Date).format("YYYY-MM-DD")

      if (this.editedItem.CheckDate)
        this.editedItem.CheckDate = moment(this.editedItem.CheckDate).format("YYYY-MM-DD")

      this.dialog = true
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      this.editedItem.ContractID = this.contractId
      //this.editedItem.DepositID = this.depositItem.ID
      //debugger
      if (this.editedIndex > -1) {
        //UPDATE
        APIService.update(this.editedItem).then(response => {
          //debugger;
          if(response.data)
          {
            if (this.editedItem.IsActive)
            {
              Object.assign(this.items[this.editedIndex], this.editedItem)
            }
            else
            {
              this.items.splice(this.editedIndex, 1)
            }
          }
          this.close()
        })
      } else {
        //CREATE
        APIService.create(this.editedItem).then(response => {
          //debugger;
          if(response.data)
            this.items.push(response.data)

          this.close()
        })
      }
    },

    savePaymentDate(item, date) {
      item.Date = date
      //menu.save(date)
      this.menu = false
    },
    saveCheckDate(item, date) {
      item.CheckDate = date
      //menu.save(date)
      this.menuCheckDate = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GridPayment.vue